import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "./pages/Portfolio";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/toaster";
import { SiteProvider } from "./context/SiteContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteProvider>
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </SiteProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
